// eslint-disable
import React, { Suspense, lazy } from "react";
import FallbackSpinner from "components/Spinner/FallbackSpinner";
import ReactDOM from "react-dom";
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";


const LazyApp = lazy(() => import('./App'))

ReactDOM.render(
  <Suspense fallback={<FallbackSpinner />}>
    <LazyApp />
    <ToastContainer />
  </Suspense>,
  document.getElementById("root")
);
